import axios from "axios";
import { ATP_API_URL } from "../apiConfig/apiConfig";

export const saveGadgetDetails = async (body) => {
  try {
    const response = await axios.post(ATP_API_URL.SaveGadgetDetails, body, {
      headers: { "Content-Type": "application/json" },
    });

    const raw = response.data;

    if (raw.success) {
      return {
        success: true,
        customerId: raw.customerid,
        message: raw.message || "Details saved successfully.",
      };
    }

    return {
      success: false,
      error: raw.message || "Failed to save gadget details.",
    };
  } catch (error) {
    console.error("[saveGadgetDetails]", error.response?.data || error.message);
    return {
      success: false,
      error:
        error.response?.data?.message ||
        error.message ||
        "Failed to save gadget details.",
    };
  }
};

export const sendGadgetPaymentRequest = async (body) => {
  try {
    const response = await axios.post(
      ATP_API_URL.SendGadgetPaymentRequest,
      body,
      { headers: { "Content-Type": "application/json" } },
    );

    const raw = response.data;

    if (raw.success) {
      return {
        success: true,
        paymentUrl: raw.message, // API returns the redirect URL in `message`
      };
    }

    return {
      success: false,
      error: raw.message || "Failed to initiate payment.",
    };
  } catch (error) {
    console.error(
      "[sendGadgetPaymentRequest]",
      error.response?.data || error.message,
    );
    return {
      success: false,
      error:
        error.response?.data?.message ||
        error.message ||
        "Failed to initiate payment.",
    };
  }
};
